/*
**************************** 
홈페이지 톡톡 배움터
*****************************
*/

import React from "react";

export default function TokTokLearn(props) {

    return (
        <div>
            <div className="mt-5 pt-2">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item small"><a href="#">엘포박스</a></li>
                    <li className="breadcrumb-item active small">제품소개</li>
                </ol>
            </div>
            <div className="container-custom w-100">
                <img className="w-100 img-fluid" src="/img/learn/toktok_learn.png"></img>
            </div>
        </div>
    )
}